import React, { FC, useEffect } from 'react';
import { Spin } from 'antd';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import SpecialistList from '../../components/SpecialistList';
import { useGetSpecialistsQuery } from '../../services/specialists';
import { DEVICES } from '../../styles/breakpoint';
import { selectBookingData } from '../../redux/slices/booking';
import analytics from '../../infra/analytics';
import {
  FIND_A_SESSION, SITE_NAME,
} from '../../constants/analytics';
import { DOCTORS_ROUTE, PHN_DOCTORS_ROUTE, PHN_ROUTE } from '../../constants/routes';

const SpecialistsContainer = styled.div`
  text-align: center;
  margin: 20px auto;
  width: 98%;
  
  ${DEVICES.desktop} {
    width: 80%;
    max-width: 1440px;
    margin-bottom: 100px;
  }
`;

const Specialists: FC = () => {
  const { speciality } = useSelector(selectBookingData);
  const { search, pathname } = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(search);
  const specialtyId = searchParams.get('specialty') || '';
  const { data: specialists, isLoading } = useGetSpecialistsQuery(speciality?.id || specialtyId);
  const specialistId = searchParams.get('id');
  // const code = searchParams.get('code');

  let specialistNew = specialists;

  // Nick B. required to hide in PHN
  // if (code === 'X7mP92qL') {
  //   specialistNew = specialists?.filter((specialist) => specialist.id !== '1ae1cd7f-fbc1-4194-966f-2c28996c7545');
  // }

  if (specialistId) {
    specialistNew = specialistNew?.filter((specialist) => specialist.id === specialistId);
  }

  useEffect(() => {
    if (!isLoading && specialistId === 'a0c8db34-72e3-417d-b0ed-bc273d8dbc08') {
      const redirectRoute = pathname.startsWith(`${PHN_ROUTE}`)
        ? `${PHN_DOCTORS_ROUTE}?id=d4f60640-5756-4d3a-ad2b-617856ce9f75`
        : `${DOCTORS_ROUTE}?id=d4f60640-5756-4d3a-ad2b-617856ce9f75`;
      navigate(redirectRoute);
    } else {
      analytics.logPageViewEvent(FIND_A_SESSION, {
        site: SITE_NAME,
        page_path: pathname,
      });
    }
  }, [isLoading, specialistId, navigate, pathname]);

  return (
    <SpecialistsContainer>
      <Spin tip="Please wait while we bring up each specialist's availabilities..." spinning={isLoading}>
        {specialistNew && <SpecialistList specialists={specialistNew} openCalendar={!!specialistId} />}
      </Spin>
    </SpecialistsContainer>
  );
};

export default Specialists;
